import React, { Component, Fragment } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Grid,Button, Table, TableBody, TableCell, TableHead, TextField, TableRow, Typography, Tooltip, IconButton, Dialog } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined"
import InfoIcon from '@material-ui/icons/Info';
import Autocomplete from "@material-ui/lab/Autocomplete"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { getAircraftDetailApi } from "./apiServices"
import { permissionCheckFnforCamo } from "../../../src/utils"
import { withSnackbar } from "notistack"
import { connect } from "react-redux"
import moment from 'moment';
import RefreshIcon from "@material-ui/icons/Refresh";
import { getAircraftTypesAc, getEngineTypesAc, getLesseeListAc, getOperatorListAc, getRegionListAc, getPlatformConstantsAc, getPortfolioListAc, getAircraftMntProgramAc, getLeaseStatus, getSubStatus, getAllAssetListAc } from "../../shared_elements/actionCreators"
import { trackActivity } from "../../utils/mixpanel"
import BasicDetailForm from "./BasicDetailForm"
import { isMobile } from "react-device-detect"
import EngineDetailForm from "./EngineDetailForm"
import { getTechSpecDetailApi } from "./apiServices"
import { getLocalStorageInfo, Comma_format } from "../../../src/utils"
import { dayMonthDateFormat } from "../../constants"
import { moduleName } from "../../constants"
import { smbcInstance } from "../../shared_elements/components"
import TechSpecListing from "./TechSpecListing";
import { withRouter,useRouteMatch,useParams,useHistory,matchPath } from 'react-router-dom/cjs/react-router-dom';
import { DeletePopUp, PageLoader } from "../../shared_elements";
import DownloadXLSAssetDetail from "../../shared_elements/DownloadXLSAssetDetail";
import { exportMasterApi,onArchiveAsset } from "./ad/apiService";
import { engineDetailObj, offWingObj } from '.';
class BasicDetailHeader extends Component {
	constructor(props) {
		super(props)
		this.state = {
			headerData: {},
			LHData: {},
			RHData: {},
			formTitle: "",
			openEditForm: false,
			openEditFormEngine: false,
			ownersList: [],
			basicDetailData: {},
			btnTypes: '',
			pageLoader:false,
			archiveModal:false,
		}
		this.getTechSpecDetailApi = getTechSpecDetailApi.bind(this)
		this.exportMasterApi = exportMasterApi.bind(this)
		this.onArchiveAsset = onArchiveAsset.bind(this);
	}

	mainHeaderData = async (props) => {
		try {
			// const response = await getAircraftDetailApi(props);
			const response = await getAircraftDetailApi(this.props,'',(val) => this.setState({ pageLoader: val }));
			const data = response.data.data;
			await this.getTechSpecDetailApi(data);
			let tempLHdata = {};
			let tempRHdata = {};

			if (data) {
				tempLHdata = data.engine_detail?.length > 0 ? data.engine_detail.find((x) => x.position.value === 1 || x.position.value === 3) : {};
				if (tempLHdata) {
					this.setState({ LHData: tempLHdata });
				}

				tempRHdata = data.engine_detail?.length > 0 ? data.engine_detail.find((x) => x.position.value === 2 || x.position.value === 4) : {};
				if (tempRHdata) {
					this.setState({ RHData: tempRHdata });
				}
			}

			this.setState({ headerData: data });
			if (this.props?.location?.pathname.split("/").at(-2) !== 'tech_spec') {
				this.props.func(data.slug, data.tsn, data.csn, data.date_of_manufacture, data?.thrust_details);
				this.props.uuid(data?.record_folders?.technical_records);
			}

			if (this.props.module === 'util' || this.props.module === 'Op' ||
				this.props.module === 'ad' || this.props.module === 'sb' ||
				this.props.module === 'inventory' || this.props.module === 'st' ||
				this.props.module === 'mc' || this.props.module === 'llp' ||
				this.props.module === 'sv') {
				this.props.engineType(data);
			}
			// await this.getTechSpecDetailApi(data);
			setTimeout(() => {
				const { basicDetailData } = this.state
				if (this.props.module === 'util') {
					this.props.engineType(data, basicDetailData);
				}
				if (this.props.module === 'sv') {
					this.props.basicData(data, basicDetailData);
				}
			}, 2000)


		} catch (error) {
			console.error("Error in mainHeaderData:", error);
		}
	};

	componentDidMount() {
		// this.getTechSpecDetailApi()
		if (this.props?.match?.params?.assetType === 2 || this.props?.match?.params?.assetType === "2") {
			this.mainHeaderData(this.props)
		}
		this.props.getPlatformConstants()
		this.props.getLesseeList()
		this.props.getOperatorList()
		this.props.getRegionList()
		this.props.getPortfolioList()
		this.props.getEngineTypes()
		this.props.getAircraftTypes()
		this.props.getLeaseStatus()
		this.props.getSubStatus()
		trackActivity("Page Visited", {
			page_title: "Camo Technical Specification",
		})
		if (!this.props.allAssets.length) {
			this.props.getAllAssetListFn()
		}
	}

	handleEditRow = () => {
		this.setState({ formTitle: "Update Assets" })
		this.setState({ openEditForm: true })
	}

	closeUpdateForm = () => {
		this.setState({ openEditForm: false })
	}
	changeAssetSwitcher = async (value) => {
		let assettype = this.props.allAssets.find(asset => asset?.slug === value?.slug)
		const response = await getAircraftDetailApi(this.props, value,(val) => this.setState({ pageLoader: val }));
		if (response) {
			if(this.props?.module){
				  this.props?.props.history.push(`/${response?.data?.data?.id}/${assettype?.asset_type}/${moduleName[this.props?.module]}/list`)
			}else{
				  this.props?.history.push(`/${response?.data?.data?.id}/${assettype?.asset_type}/tech_spec/list`)
			}
		}
		setTimeout(() => { window.location.reload(false) }, 500)
	}
	tecSpecEditFn = (type) => {
		this.setState({
			openEditFormEngine: true, formTitle: "Update Technical Specification", btnTypes: type,
		})
		return
	}
	render() {
		const { asset, assetType } = this.props?.match?.params
		const { ownersList, headerData, basicDetailData, btnTypes ,pageLoader,archiveModal} = this.state
		const { portfolios, aircraftTypes, pltConstants, lessees, operators, aircraftMntGrp, leaseStatus, subStatus, svData, allAssets } = this.props
		let selectedAsset = allAssets.find(asset => asset?.slug === basicDetailData?.slug && asset?.asset_type == assetType)
		
		return (
			<Fragment>
				<Grid container spacing={1} style={{marginTop:this.props?.location?.pathname.split("/").at(-2) === 'tech_spec' ? '5px' : ''}}>
					{assetType == 1 ? null :<Grid item xs={12} md={4} sm={4}>
						<Autocomplete
							options={allAssets || []}
							disabled={!basicDetailData?.slug}
							getOptionLabel={(option) => option?.unique_name}
							value={selectedAsset ? selectedAsset : ''}
							onChange={(e, value) => value ? this.changeAssetSwitcher(value) : e.preventDefault()}
							renderInput={params => <TextField {...params} margin="none" fullWidth InputLabelProps={{ shrink: true }} disabled={!basicDetailData?.slug} />}
						/>
					</Grid>}
					{this.props?.location?.pathname.split("/").at(-2) === 'tech_spec' ? <Grid item xs={12} md={4} sm={4} className="export-list">
						<DownloadXLSAssetDetail files={{ title: "Master Export", extension: "xlsx", key: "" }} exportReportFn={(file) => this.exportMasterApi({ download: file.extension }, "pageLoader", this.props)} style={{ color: "#bd10e0" }} />
					</Grid> : null}
					{this.props?.location?.pathname.split("/").at(-2) === 'tech_spec' ? <Grid item xs={12} md={4} sm={4} style={{ textAlign: 'right' }}>
						{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ?<> <Tooltip title={this.props?.location?.search === '?archived-assets' ? 'ARCHIVE' : "ARCHIVE ASSET"}>
							<Button
								onClick={() => this.props?.location?.search !== '?archived-assets' && this.setState({ archiveModal: true })}
								color={this.props?.location?.search === '?archived-assets' ? 'black' : 'primary'}
								size='small' variant='outlined'
								style={{ background: this.props?.location?.search === '?archived-assets' && 'linear-gradient(269deg, #e1e1e1, #b3b3b3)' }}>
								{this.props?.location?.search === '?archived-assets' ? 'ARCHIVE' : 'ARCHIVE ASSET'}
							</Button>
						</Tooltip>
							<Tooltip title="Refresh">
								<IconButton className="p-5px" color="primary" onClick={() => this.mainHeaderData(this.props)} >
									<RefreshIcon />
								</IconButton>
							</Tooltip>
						</>
							: null}
					</Grid> : null}
				</Grid> 
				<div id="AmpTableHeader">
					<Accordion defaultExpanded>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon className="p-5" />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							<Typography>Basic Details</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Grid container>
								<Grid
									className="left-panel"
									item
									xs={12}
									style={{ backgroundColor: " #efefef" }}
								>
									<Table className="table-wrapper">
										<TableHead>
											<TableRow>
												<TableCell className="font-b">{assetType == 1 ? "Aircraft Type/Model" : "Engine Type/Model"}</TableCell>
												<TableCell className="font-b">{assetType == 1 ? "MSN" : "ESN"}</TableCell>
												{assetType == 1 && <TableCell className="font-b">Registration</TableCell>}
												<TableCell className="font-b">Date of Manufacture</TableCell>
												<TableCell className="font-b"> {assetType == 1 ? "A/C TSN" : "Engine TSN"}</TableCell>
												<TableCell className="font-b"> {assetType == 1 ? "A/C CSN" : "Engine CSN"}</TableCell>
												{assetType === 2 ? <TableCell className="font-b"></TableCell> : null}
												{window?.location?.search.includes('archived-assets') ? null : getLocalStorageInfo()?.user?.security_groups?.find(item => item?.id === 29) ?
													<div id="edit-basic-detail" className="d-flex">
														<span class="editBasicDetail">
															{/* {permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "U", }) ? */}
															{/* {checkPermission('camo','asset_management','U') ? */}
															<Tooltip title="Edit">
																<IconButton
																	className="edit-asset-icon"
																	onClick={(e) => {
																		this.handleEditRow(e)
																	}}
																>
																	<CreateOutlinedIcon />
																</IconButton>
															</Tooltip>
															{/* : null} */}
														</span>
													</div> : null}
											</TableRow>
										</TableHead>
										<TableBody>
											<TableRow>
												<TableCell >
													{assetType == 1 ? this.state.headerData?.aircraft_type_name : this.state.headerData.engine_type_name}
												</TableCell>
												<TableCell >
													{assetType == 1 ? this.state?.headerData?.msn : this.state?.headerData?.esn}
												</TableCell>
												{assetType == 1 && <TableCell >
													{this.state.headerData.current_registration_number ? this.state.headerData.current_registration_number : " -- "}
												</TableCell>}
												<TableCell >
													{this.state.headerData.date_of_manufacture ? moment(this.state.headerData.date_of_manufacture).format(dayMonthDateFormat) : " -- "}
												</TableCell>
												<TableCell >
													{this.state.headerData.tsn >= 0 ? Comma_format((this.state.headerData.tsn).toFixed(2)) : "--"}
												</TableCell>
												<TableCell >
													{this.state.headerData.csn >= 0 ? Comma_format(parseInt(this.state.headerData.csn)) : "--"}
												</TableCell>
											</TableRow>
										</TableBody>
										{assetType == 1 && <TableHead className="table-head">
											<TableRow>
												<TableCell className="font-b">LH Engine Type(Serial No)</TableCell>
												<TableCell className="font-b">LH Engine TSN</TableCell>
												<TableCell className="font-b">LH Engine CSN</TableCell>
												<TableCell className="font-b">RH Engine Type/Serial No</TableCell>
												<TableCell className="font-b">RH Engine TSN</TableCell>
												<TableCell className="font-b">RH Engine CSN</TableCell>
											</TableRow>
										</TableHead>}
										{assetType == 2 && <TableHead className="table-head">
											<TableRow>
												<TableCell className="font-b">{smbcInstance ? 'TSPR' :'TSLSV'}</TableCell>
												<TableCell className="font-b">{smbcInstance ? 'CSPR' :'CSLSV'}</TableCell>
												<TableCell className="font-b">LLP Limiter(s)</TableCell>
												<TableCell className="font-b">Soft-time Limiter(s)</TableCell>
												<TableCell className="font-b">Op. Thrust (Current)</TableCell>
												<TableCell className="font-b"></TableCell>
											</TableRow>
										</TableHead>}

										{assetType == 1 && <TableBody>
											<TableRow>
												<TableCell >
													{this.state?.LHData?.engine_type?.name ? `${this.state.LHData?.engine_type?.name + " "}(${this.state.LHData?.esn})` : " -- "}
												</TableCell>
												<TableCell >
													{this.state.LHData && this.state.LHData.tsn ? Comma_format(this.state.LHData.tsn) : " -- "}
												</TableCell>
												<TableCell >
													{this.state.LHData && this.state.LHData.csn ? Comma_format(parseInt(this.state.LHData.csn)) : " -- "}
												</TableCell>
												<TableCell >
													{this.state?.RHData?.engine_type?.name ? `${this.state.RHData?.engine_type?.name + " "}(${this.state.RHData?.esn})` : " -- "}
												</TableCell>
												<TableCell >
													{this.state.RHData && this.state.RHData.tsn ? Comma_format(this.state.RHData.tsn) : " -- "}
												</TableCell>
												<TableCell>
													{this.state.RHData && this.state.RHData.csn ? Comma_format(this.state.RHData.csn) : " -- "}
												</TableCell>
											</TableRow>
										</TableBody>}
										{assetType == 2 && <TableBody>
											<TableRow>
												<TableCell>
													{headerData?.tslv > 0 ? Comma_format((headerData?.tslv).toFixed(2)) : 0}
												</TableCell>
												<TableCell >
													{headerData?.cslv > 0 ? Comma_format(parseInt(headerData?.cslv)) : 0}
												</TableCell>
												<TableCell >
													{headerData?.llp_limiter > 0 ? Comma_format(parseInt(headerData?.llp_limiter)) : headerData?.llp_limiter === null ? 'N/A' : 0}
												</TableCell>
												<TableCell >
													{headerData?.soft_time_limiter > 0 ? Comma_format(parseInt(headerData?.soft_time_limiter)) : headerData?.soft_time_limiter === null ? 'N/A' : 0}
												</TableCell>
												<TableCell >
													{headerData?.current_operating_thrust?.name ? headerData?.current_operating_thrust?.name : " -- "}
												</TableCell>
											</TableRow>
										</TableBody>}
										{assetType == 2 && <TableHead className="table-head">
											<TableRow>
												<TableCell className="font-b">Reporting Month
													<Tooltip title="Update (Utilization As of Date)" placement="top"><InfoIcon size='small' style={{ verticalAlign: 'middle', fontSize: "small", paddingLeft: '3px' }} /></Tooltip></TableCell>
											</TableRow>
										</TableHead>}
										{assetType == 2 && <TableBody>
											<TableRow>
												<TableCell>
													{headerData?.last_utilization_updated ? moment(headerData?.last_utilization_updated).format(dayMonthDateFormat) : " -- "}
												</TableCell>
											</TableRow>
										</TableBody>}
									</Table>
								</Grid>
							</Grid>
						</AccordionDetails>
					</Accordion>
				</div>
				{this.props?.location?.pathname.split("/").at(-2) !== 'tech_spec' ? null :
					<TechSpecListing assetType={assetType} basicDetailData={basicDetailData} assetsDetail={this.props?.assetsDetail} tecSpecEdit={this.tecSpecEditFn} />
				}
				<Dialog
					position="relative"
					maxWidth="lg"
					open={this.state.openEditForm}
					onClose={this.closeUpdateForm}
					style={{ height: isMobile && "650px" }}
				>
					<BasicDetailForm
						props={this.props}
						closeUpdateForm={() => this.closeUpdateForm()}
						fetchMntGrops={(aircraftId) =>
							this.props.getAircraftMntProgram(aircraftId)
						}
						aircraftMntGrp={aircraftMntGrp}
						leaseStatus={leaseStatus}
						subStatus={subStatus}
						portfolios={portfolios}
						ownersList={ownersList}
						lessees={lessees}
						operators={operators}
						pltConstants={pltConstants}
						aircraftTypes={aircraftTypes}
						headerData={headerData}
						asset={asset}
						LHData={this.state.LHData}
						RHData={this.state.RHData}
						assetType={assetType}
					/>
				</Dialog>
				<Dialog
					position="relative"
					maxWidth="lg"
					open={this.state.openEditFormEngine}
					// onClose={() => this.setState({ openEditFormEngine: false })}
					style={{ height: isMobile && "650px" }}
					className="engine-tech-spec"
				>
					<EngineDetailForm
						closeUpdateForm={() =>this.setState({openEditFormEngine:false})}
						slug={headerData.slug}
						basicDetailData={basicDetailData}
						getResponseBack={() => this.getTechSpecDetailApi(headerData)}
						assetDetail={headerData}
						assets={this.props.assetsDetail}
						svData={svData}
						pltConstants={pltConstants}
						btnTypes={btnTypes}
					/>
				</Dialog>
				{this.props?.location?.pathname.split("/").at(-2) !== 'tech_spec' ? null : pageLoader ? <PageLoader /> : null}
				{
					archiveModal ?
						<DeletePopUp
							title='Archive Asset'
							deleteRecordFn={() => this.onArchiveAsset(this.props, headerData?.slug)}
							modal={() => this.setState({ archiveModal: true })}
							content='Are you sure, you want to Archive?'
							toggleModalFn={() => this.setState({ archiveModal: false })}
							confirmText="ARCHIVE"
						/>
						: null
				}
			</Fragment>

		)
	}
}

const mapStateToProps = (state) => ({
	aircraftTypes: state.shareReducer.aircraftTypes,
	engineTypes: state.shareReducer.engineTypes,
	lessees: state.shareReducer.lessees,
	operators: state.shareReducer.operators,
	regions: state.shareReducer.regions,
	portfolios: state.shareReducer.portfolios,
	pltConstants: state.shareReducer.pltConstants,
	aircraftMntGrp: state.shareReducer.aircraftMntGrp,
	leaseStatus: state.shareReducer.leaseStatus,
	subStatus: state.shareReducer.subStatus,
	allAssets: state.shareReducer.allAssets,
})
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		getAircraftTypes: (props, query) =>
			dispatch(getAircraftTypesAc(props, query)),
		getRegionList: () => dispatch(getRegionListAc()),
		getEngineTypes: (query) => dispatch(getEngineTypesAc(query)),
		getLesseeList: () => dispatch(getLesseeListAc()),
		getOperatorList: () => dispatch(getOperatorListAc()),
		getPortfolioList: () => dispatch(getPortfolioListAc()),
		getAircraftMntProgram: (aircraftId) =>
			dispatch(getAircraftMntProgramAc(aircraftId)),
		getPlatformConstants: () =>
			dispatch(getPlatformConstantsAc({ constant_types: ["asset_status", "credit_classification", "engine_position", "lg_position", "off_wing_status", "shop_visit_type", "workscope_status", "sv_report_status", "sv_requirement"], })),
		getLeaseStatus: () => dispatch(getLeaseStatus({ constant_types: ["lease_status"] })),
		getSubStatus: () =>
			dispatch(getSubStatus({ constant_types: ["asset_sub_status"] })),
		getAllAssetListFn: () => dispatch(getAllAssetListAc()),
	}
}

export default withRouter(withSnackbar(
	connect(mapStateToProps, mapDispatchToProps)(BasicDetailHeader))
)
